module.exports = __webpack_public_path__ + "static/other/program_robot.971b71f4.json";


//////////////////
// WEBPACK FOOTER
// ./src/assets/qci/maps/program_robot.json
// module id = 2446
// module chunks = 0